// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"7a118622","570":"321044c6"}[chunkId] + ".chunk.js";
};